import * as React from 'react';
import Box from '@mui/material/Box';
import List from '@mui/material/List';
import pxToRem from 'assets/theme/function/px-to-rem';
import colors from 'assets/theme/base/colors';
import { MenuItemParams } from 'types/routes/route-params';
import MenuItem from 'layouts/protected/side-bar/menu-item';

interface Props {
    menuItems: MenuItemParams[];
}

const SideBar: React.FC<Props> = (props: Props) => {
    const { menuItems } = props;

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                width: pxToRem(270),
                bgcolor: colors.secondary.main,
                minHeight: '90vh',
                maxHeight: 'calc(100vh - 300px)',
                overflow: 'hidden',
            }}
        >
            <Box>
                <List component="nav" aria-label="side bar menu">
                    {menuItems.map(
                        (routeParam: MenuItemParams, index: number) =>
                            !routeParam?.icon ? null : (
                                <MenuItem key={index} routeParam={routeParam} />
                            ),
                    )}
                </List>
            </Box>
        </Box>
    );
};

export default SideBar;
